import { MessageTypeEnum } from '@gr/shared/enums';
import { ICampaignGetTypesRequest, ICampaignGetTypesResponse, IHttpResponse } from '@gr/shared/models';
import { useQuery } from '@tanstack/react-query';
import { axiosPost } from '../authAxios';

export default function useCampaignTypesForClient(clientId?: string, messageType?: MessageTypeEnum) {
  return useQuery({
    queryKey: ['campaign-types', clientId, messageType],
    queryFn: async () => {
      const axios = await axiosPost<IHttpResponse<ICampaignGetTypesResponse>>('campaigns-get-types-for-client', {
        clientId,
        messageType,
      } as ICampaignGetTypesRequest);
      return axios.data?.data;
    },
    enabled: !!clientId && !!messageType,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
